import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Avatar from '../../uikit/avatar';

export default function PersonalNotificationToast({ message }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/message/personal/${message.senderId}/${message.receiverId}`);
  };

  return (
    <div
      className="flex items-center max-w-sm p-2 mx-auto space-x-4 text-white bg-black rounded-lg shadow-md bg-opacity-20 backdrop-blur-md w-80 cursor-pointer"
      onClick={handleClick}
    >
      <div className="flex items-center justify-center">
        <Avatar
          text={message.senderFullName || message.senderName || ' '}
          textSize={20}
          imageUrl={message.senderImage || ''}
        />
      </div>
      <div className="flex-1">
        <h2 className="text-lg font-semibold">
          {message.senderFullName || message.senderName || ' '}
        </h2>
        <p className="mt-1 text-base line-clamp-1">{message.textMessage}</p>
      </div>
    </div>
  );
}

PersonalNotificationToast.propTypes = {
  message: PropTypes.shape({
    senderId: PropTypes.string.isRequired,
    receiverId: PropTypes.string.isRequired,
    senderFullName: PropTypes.string,
    senderName: PropTypes.string,
    senderImage: PropTypes.string,
    textMessage: PropTypes.string.isRequired,
  }).isRequired,
};
